import { render, staticRenderFns } from "./content-box.vue?vue&type=template&id=36986abc&scoped=true&"
import script from "./content-box.vue?vue&type=script&lang=js&"
export * from "./content-box.vue?vue&type=script&lang=js&"
import style0 from "./content-box.vue?vue&type=style&index=0&id=36986abc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36986abc",
  null
  
)

export default component.exports